module.exports = __webpack_public_path__ + "img/motion.7a35cbd8.svg";